export const broadCastConstant = {
    BROADCAST_REQUEST: 'BROADCAST_REQUEST',
    BROADCAST_GET_SUCCESS: 'BROADCAST_GET_SUCCESS',
    UPDATE_BROADCAST_SUCCESS : 'UPDATE_BROADCAST_SUCCESS',
    DELETE_BROADCAST_SUCCESS : 'DELETE_BROADCAST_SUCCESS',
    BROADCAST_FAILURE: 'BROADCAST_FAILURE',
    EXPORT_BROADCAST_REQUEST: 'EXPORT_BROADCAST_REQUEST',
    EXPORT_BROADCAST_SUCCESS: 'EXPORT_BROADCAST_SUCCESS',
    EXPORT_BROADCAST_FAILURE: 'EXPORT_BROADCAST_FAILURE',
    BROADCAST_USER_TYPE_ALL: 'all',
    BROADCAST_USER_TYPE_TEAM: 'team',
    BROADCAST_MSG_CHAR_LENGTH: 250,
    BROADCAST_MSG_TYPE_CHAR_LENGTH: 100
}
